<template>
  <div class="post">
    <!-- header -->
    <div class="post_header mt-4">
      <!-- title -->
      <h3 class="float-left">{{ FAQ.title }}</h3>
      <!-- buttons [Update, publish|unpublish , delete] -->
      <div class="btn-group float-right" role="group" aria-label="Basic example">
        <router-link class="btn btn-success" :to="'/faqs/update-faq/' + this.FAQ.slug">Update</router-link>
        <template>
          <button v-if="FAQ.published == 0" @click="publishing('publish')" type="button"
            class="btn btn-primary btn-sm">Publish</button>
          <button v-else @click="publishing('unpublish')" type="button"
            class="btn btn-warning text-dark btn-sm">Unpublish</button>
        </template>
        <!-- v-if="$gate.allow('delete', 'FAQ', FAQ)" -->
        <button @click="deleteFAQ" type="button" class="btn btn-danger">Delete</button>
      </div>
      <span class="clearfix d-block mb-3"></span>
    </div>
    <!-- info -->
    <hr>
    <p class="lead post_info">
      Created by
      <template>
        {{ FAQ.author.name }}
      </template>
      <!-- <template v-else>
        unknown
      </template> -->
      <!--<span v-if="FAQ.published == 1" class="float-right"><strong>Published:</strong> {{ FAQ.published_at }}</span>-->
    </p>
    <hr>
    <!-- Post Content -->
    <div class="post_content">
      <!--<div v-if="caption != 0" class="text-center">-->
      <!--&lt;!&ndash;<img class="img-fluid" :src="caption" alt="Answer">&ndash;&gt;-->
      <!--<hr>-->
      <!--</div>-->
      <p v-html="body"></p>
    </div>
    <hr>
    <p v-html="video"></p>
  </div>
</template>
<script>
  export default {
    components: {

    },
    data: function () {
      return {
        isupdated: false,
      }


    },
    computed: {
      FAQ: function () {
        return this.$store.getters['faqs/FAQ'];
      },

      body: function () {

        if (this.FAQ.body) {
          return this.FAQ.body.replace(/"faqs\/images\/.*?\.png/g, (imagePath) => {
            return '"' + this.$baseURL + '/storage/' + imagePath.substr(1);
          });
        }
        return '';
      },
      video: function () {

        if (this.FAQ.video) {
          return this.FAQ.video;
        }
        return '';
        }
    },
    created: function () {
      this.$store.dispatch('faqs/getFAQ', this.$route.params.FAQ);
    },
    methods: {
      deleteFAQ() {
        this.$store.dispatch('message/update', {
          title: this.FAQ.title,
          body: 'Are you sure you want to delete this FAQ?',
          class: 'danger',
          confirm: true
        });

        // this.$bus.$off('proceed');
        this.$bus.$once('proceed', () => {
          this.delete(this.FAQ);
          this.$store.dispatch('message/close');
          this.$router.push('/faqs');
        });
      },

      delete(FAQ) {
        this.$store.dispatch('faqs/deleteFAQ', FAQ)
          .then((message) => {
            // send successful message
            this.$toast.success(message);
          })
          .catch((error) => {
            // send error message
            this.$toast.error(error.response.data.message);
          });
      },
      publishing(action) {
        this.$store.dispatch('faqs/publishing', {
          FAQ: this.FAQ,
          action: action
        })
          .then((response) => {
            this.$toast.success(response.data.message);
          });
      },

    }
  }
</script>
<style>
  img {
    max-width: 100% !important;
    max-height: 100% !important;
  }
</style>